module.exports = __webpack_public_path__ + "img/edge_activites_ping_pong.dad1ca86.svg";